
class Cache {
    /**
     * @param {object} options
     * @param {array} options.prefix 缓存前缀
     */
    constructor(options = {}) {
        const { prefix = 'cache' } = options;
        this.prefix = prefix;
    }

    /**
     * 设置缓存前缀
     * @param {string} prefix 前缀
     */
    setPrefix(prefix) {
        this.prefix = prefix;
    }

    /**
     * 获取本地缓存的Key
     * @param {string} sign 缓存键标识
     */
    getCacheKey(sign) {
        let key = '';
        if (this.prefix) {
            key += `${this.prefix}_`;
        }
        key += sign;

        return key;
    }

    /**
     * 查看缓存状态
     * @param {string} sign 缓存键标识
     * @return {string} cacheStatus 缓存状态
     */
    getCacheStatus(sign) {
        const cacheKey = this.getCacheKey(sign);
        const cacheStatus = localStorage && localStorage.getItem(cacheKey);

        return cacheStatus;
    }

    /**
     * 设置缓存状态
     * @param {string} sign 缓存键标识
     */
    setCacheStatus(sign, value = 1) {
        const cacheKey = this.getCacheKey(sign);
        localStorage && localStorage.setItem(cacheKey, value);
    }
}

export default Cache;
